<template>
  <section>
    <div class="container">
      <vx-card v-if="json_response">
        <h3 class="mb-base">JSON Response
          <vs-button class="get-started-btn float-right" @click.stop="openConfirmPopup">Sync With Editor</vs-button>
        </h3>
        <div class="w-full">
          <pre>
            <vue-json-pretty :path="'res'" :data="json_response" :deep="1"> </vue-json-pretty>
          </pre>
        </div>
      </vx-card>
    </div>
    <vs-popup title="Are You Sure?..." :active.sync="confirmSync">
      <h2 class="card-title">This action will make these changes...</h2>
      <p class="p-10 card-description">
        Your Personal, Personality, Extra Curricular details will be overwritten and rest of the data like Skills,
        Education and Experience etc will be appended.
      </p>
      <div class="flex justify-end">
        <vs-button class="btn-primary rounded mr-2" @click.stop="syncAPI()">Go Ahead</vs-button>
        <vs-button class="vs-button-light rounded text-primary" @click.stop="closeConfirmPopup">Cancel</vs-button>
      </div>
      <hr class="my-5" />
      <p class="text-danger">PS: If in doubt append the data and then manually delete entries from the editor.</p>
    </vs-popup>
  </section>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
  data() {
    return {
    }
  },
  components: {
    VueJsonPretty,
  },
  name: "JsonResponse",
  computed: {
    confirmSync() {
      return this.$store.state.parser.confirmSync;
    },
    json_response() {
      if (this.$store.state.parser.json_response !== null) {
        return this.$store.state.parser.json_response;
      } else {
        return null;
      }
    }
  },
  methods: {
    openConfirmPopup() {
      this.$store.commit('parser/SET_CONFIRM_SYNC', true)
    },
    closeConfirmPopup() {
      this.$store.commit('parser/SET_CONFIRM_SYNC', false)
    },
    syncAPI() {
      console.log('this.$store.state.parser.json_response', this.$store.state.parser.json_response);
      const payload = {
        id: this.$store.state.auth.user._id,
        syncData: this.$store.state.parser.json_response
      }
      this.$vs.loading();
      this.$store
        .dispatch("parser/syncEditor", payload)
        .then(res => {
          // console.log("syncing successfully completed",res);
          // this.confirmSync = false;
          this.closeConfirmPopup();
          this.$vs.loading.close();
          const accessToken = localStorage.getItem('accessToken');
          const user = JSON.parse(localStorage.getItem('user'));
          window.location.href = `https://editor.getboarded.com/oauth-callback?organization=default&token=${accessToken}&userId=${user._id}`;
          // this.$router.push('/editor/about');
        })
        .catch((err) => {
          this.closeConfirmPopup();
          throw err;
        });
    }
  }
}
</script>

<style scoped>
.items-center {
  text-align: center;
  text-align: -moz-center;
  text-align: -webkit-center;
}

section {
  padding: 2rem 10rem 2rem 10rem;
  background: #FFFFFF;
  position: relative;
}

pre {
  padding: 2rem;
  background: #F7F8F9;
  border-radius: 12px;
  overflow: auto;
}

@media (max-width: 1200px) {
  section {
    padding: 2rem 0rem 2rem 0rem;
  }
}
</style>
